import './index.scss';

const Toast = () => {};

let rootNode = null;

const hide = (node) => {
  if(rootNode) {
    rootNode.removeChild(node);
  }
};

const show = ({ content = '', container = document.body, duration = 2000 }) => {
  if (!rootNode) {
    rootNode = document.createElement('div');
    rootNode.classList.add('toast-container');
    container.append(rootNode);
  }

  const children = document.createElement('div');
  children.classList.add('toast-content');
  children.textContent = content;
  rootNode.appendChild(children);

  setTimeout(() => hide(children), duration);
};

Toast.show = show;
Toast.hide = hide;

export default Toast;
